import React, { useContext, useState } from 'react';
import { Button, Card, Col, Container, FloatingLabel, Form, Image, Row } from 'react-bootstrap';
import toast, { Toaster } from 'react-hot-toast';
import { useNavigate } from 'react-router-dom';
import { AuthContext } from '../Auth/authContext';

function Login() {
  const navigate = useNavigate();
  const [username, setUsername] = useState('');
  const [pass, setPass] = useState('');
  const [validated, setValidated] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const { logins } = useContext(AuthContext);

  const handleLogin = async (event) => {
    event.preventDefault();
    const form = event.currentTarget;
    setValidated(true);

    if (!form.checkValidity()) {
      event.stopPropagation();
      return;
    }

    setSubmitting(true);
    try {
      await logins(username.trim(), pass);
      navigate('/calendario', { replace: true });
    } catch (_error) {
      toast.error('Dati errati oppure utenza non autorizzata. Riprova.');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <main className="login-page">
      <Toaster position="top-center" />
      <Container>
        <Row className="justify-content-center">
          <Col xs={12} sm={10} md={7} lg={5} xl={4}>
            <div className="login-brand">
              <Image src="/logo.png" alt="Centro di Fisioterapia Spazio Vitale" fluid />
              <p>Agenda sanitaria</p>
            </div>
            <Card className="login-card border-0">
              <Card.Body>
                <h1>Accesso</h1>
                <p className="login-subtitle">Inserisci le credenziali per gestire l’agenda.</p>
                <Form noValidate validated={validated} onSubmit={handleLogin}>
                  <FloatingLabel controlId="username" label="Username" className="mb-3">
                    <Form.Control
                      type="text"
                      value={username}
                      onChange={(event) => setUsername(event.target.value)}
                      placeholder="Username"
                      minLength={4}
                      autoComplete="username"
                      required
                      autoFocus
                    />
                    <Form.Control.Feedback type="invalid">Inserisci almeno 4 caratteri.</Form.Control.Feedback>
                  </FloatingLabel>
                  <FloatingLabel controlId="password" label="Password" className="mb-3">
                    <Form.Control
                      type="password"
                      value={pass}
                      onChange={(event) => setPass(event.target.value)}
                      placeholder="Password"
                      minLength={4}
                      autoComplete="current-password"
                      required
                    />
                    <Form.Control.Feedback type="invalid">Inserisci almeno 4 caratteri.</Form.Control.Feedback>
                  </FloatingLabel>
                  <div className="d-grid">
                    <Button type="submit" size="lg" disabled={submitting}>
                      {submitting ? 'Accesso in corso…' : 'Accedi'}
                    </Button>
                  </div>
                </Form>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>
    </main>
  );
}

export default Login;
